import {combineReducers} from "redux";
import {sectionPagesReducer} from "./sectionsPages/sectionsPages.reducer";


export const reducer = combineReducers({
    sectionPagesReducer
})